<script lang="ts">
    import { TimeWindow } from '../TimeWindow';

    export let timeWindow: TimeWindow;
</script>

<div style="display: flex; flex-direction: row; align-items: center; justify-content: center;  column-gap: 4px; font-weight: 400; ">
    {#if timeWindow.getTimeWindow().from !== null}
        <svelte:component this={timeWindow.getColorComponentFrom()}>
            {timeWindow.getTimeWindow().from}
        </svelte:component>
    {/if}
    <div>-</div>
    {#if timeWindow.getTimeWindow().to !== null}
        <svelte:component this={timeWindow.getColorComponentTo()}>
            {timeWindow.getTimeWindow().to}
        </svelte:component>
    {/if}
</div>
